import { Switch } from "@headlessui/react";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { MdDone } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
interface SwitchProps {
  proimaryText?: string;
  seconderytext?: string;
  handelFunction?: (e: boolean) => void;
  isBilable?: boolean;
}
const SwitchMainComponent = ({ handelFunction, proimaryText, seconderytext, isBilable }: SwitchProps) => {
  const [isChecked, setIsChecked] = useState(false);

  const handelChange = () => {
    setIsChecked((prev) => !prev);
    handelFunction(isChecked);
  };

  useEffect(() => {
    if (isBilable === false) {
      setIsChecked(false);
    }
  }, [isBilable]);

  return (
    <div className="flex items-center gap-4">
      {proimaryText && <p className="whitespace-nowrap text-[#000000] font-semibold">{proimaryText}</p>}
      <Switch
        checked={isChecked}
        onChange={() => {
          handelChange();
        }}
        className={clsx(
          isChecked ? "bg-[#F05B72]" : "bg-gray-200",
          "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2",
        )}
      >
        <span
          aria-hidden="true"
          className={clsx(
            isChecked ? "translate-x-5" : "translate-x-0",
            "pointer-events-none flex justify-center items-center h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
          )}
        >
          {isChecked ? <MdDone className="w-4 h-4" /> : <RxCross2 className="w-4 h-4" />}
        </span>
      </Switch>
      {seconderytext && <p className="whitespace-nowrap">{seconderytext}</p>}
    </div>
  );
};

export default SwitchMainComponent;
